$(function() {
    let tab = window.location.search.match(/tab=([^&]+)/);
    if (tab) {
        tab = tab[1];
    }
    const isDeliveryTab = tab === 'delivery' || tab === 'pick_up_delivery';
    
    setPickers();
    setDeliveryModal();
    setOrderColdDeliveryTimePicker();
    setOrderWarmDeliveryTimePicker();
    if (isDeliveryTab) {
        setOrderSearchDatePickersForDeliveryTab();
    } else {
        setOrderSearchDatePickers();
    }
})

let setPickers = function() {
    let locale = 'da'
    let dateOnlyFormat = 'L'
    let timeOnlyFormat = 'LT'
    let dateFormat = 'D-M-YYYY'
    let dateTimeFormat = 'D-M-YYYY HH:mm'
    const moment = require('moment');
       moment.updateLocale(locale, {
        week: {
            dow: 2 // 0 = Sunday, 1 = Monday, 2 = Tuesday
        }
    });

    $('.datetimepicker-force-time').datetimepicker({ locale: locale, format: dateTimeFormat, icons : { time: "fa fa-clock" }, calendarWeeks: true})
    $('.datetimepicker').datetimepicker({ locale: locale, format: dateFormat, useCurrent: false, calendarWeeks: true})

    let userRole = $('#user_role').data("role-name")
    $('.order-datetimepicker').datetimepicker({ locale: locale, format: dateFormat, useCurrent: false, minDate: userRole === 'admin' ? false : new Date(), calendarWeeks: true})
    $('.timepicker').datetimepicker({ locale: locale, format: timeOnlyFormat, stepping: (userRole === 'admin' || userRole === 'employee') ? 5 : 15, calendarWeeks: true })
    $('input.number-input').bootstrapNumber();

    $('.datetimepicker-force-time, .order-datetimepicker, .datetimepicker, .timepicker').attr("autocomplete", "off");
}

$(document).on('mouseenter', '.bootstrap-datetimepicker-widget table td.cw', function() {
    let weekNumber = $(this).text().trim();
    $(this).addClass('show-week-tooltip').attr('data-week', weekNumber);
});

let setOrderColdDeliveryTimePicker = function() {
    $('#order_delivery_time_to').prop("disabled", true)
    let el = $('#order_delivery_time_from')
    el.on("dp.change", function() {
        setOrderDeliveryTimeTo()
    });
    setOrderDeliveryTimeTo()
}

let setOrderWarmDeliveryTimePicker = function() {
    $('#order_serving_time_to').prop("disabled", true)
    let el = $('#order_serving_time')
    el.on("dp.change", function() {
        setOrderServingTimeTo()
    });
    setOrderServingTimeTo()
}

let setOrderDeliveryTimeTo = function() {
    let el = $('#order_delivery_time_to')
    if (el.length > 0) {
        let date = $('#order_delivery_time_from').data("DateTimePicker").date()
        if (date) {
            date.add(2, 'hours')
            el.data('DateTimePicker').date(date)
        }
    }
}
window.clearDatepickerFields = function() {
    const from = $('#_search_delivery_date_from')
    const to = $('#_search_delivery_date_to')
    from.val("");
    to.val("");
    from.val("").trigger("input");
    to.val("").trigger("input");
}

let setOrderServingTimeTo = function() {
    let el = $('#order_serving_time_to')
    if (el.length > 0) {
        let date = $('#order_serving_time').data("DateTimePicker").date()
        if (date) {
            date.add(30, 'minutes')
            el.data('DateTimePicker').date(date)
        }
    }
}

let setDeliveryModal = function() {
    $('#order_delivery_date').on("focusout", function(e) {
        let bookingDeadlineDays = parseInt($('#order-date-modal').data('booking-deadline') || 7);
        let days = bookingDeadlineDays * 24 * 60 * 60 * 1000;
        if ($(this).data("DateTimePicker").date() - new Date() <= days) {
            $('#order-date-modal').modal({ show: true })
        }
    })
}

let setDownloadDisabledState = (to,from) => {
    if (from.length === 0 || to.length === 0) {
        return;
    }
    if (from.val() == "" || !to.data('DateTimePicker').date() ||
        to.val() == "" || !from.data('DateTimePicker').date())
    {
        $("#download-all-btn").prop("disabled", true);
        $("#download-excel-btn").prop("disabled", true);
        
    }
    else
    {
        $("#download-all-btn").prop("disabled",false);
        $("#download-excel-btn").prop("disabled",false);
    }
}

let setOrderSearchDatePickers = function() {
    const from = $('#_search_delivery_date_from')
    const to = $('#_search_delivery_date_to')

    setDownloadDisabledState(from, to)

    from.on('dp.change', function (e) {
        if (!from.data('DateTimePicker').date()) {
            return;
        }
        if (to.data('DateTimePicker').date() < e.date && to.val() != "") {
            to.data('DateTimePicker').date(e.date)
        }
    })
    to.on('dp.change', function (e) {
        if (!to.data('DateTimePicker').date()) {
            return;
        }
        if (from.data('DateTimePicker').date() > e.date && from.val() != "") {
            from.data('DateTimePicker').date(e.date)
        }
    })
    from.on('input change dp.change', function (e) { 
        setDownloadDisabledState(from, to)
    });
    to.on('input dp.change', function (e) {
        setDownloadDisabledState(from, to)
    });
    // Initial value for TO picker
    if (from.length && to.length && !to.data('DateTimePicker').date()) {
        to.data('DateTimePicker').date(from.data('DateTimePicker').date())
    }
}

let setOrderSearchDatePickersForDeliveryTab = function() {
    const from = $('#_search_delivery_date_from')
    const to = $('#_search_delivery_date_to')
    from.on('dp.change', function(e) {
        to.data('DateTimePicker').date(e.date)
    })
    to.on('dp.change', function(e) {
        if (from.data('DateTimePicker').date() > e.date) {
            from.data('DateTimePicker').date(e.date)
        }
    })
    // Initial value for TO picker
    if (from.length && to.length && !to.data('DateTimePicker').date()) {
        to.data('DateTimePicker').date(from.data('DateTimePicker').date())
    }
}

